const style: React.CSSProperties = {
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100vh',
  width: '100vw',
  background: '#f4f6f8',
}

interface CenterWrapperProps {
  children?: React.ReactNode
}

export const CenterWrapper: React.FC<CenterWrapperProps> = ({ children }) => {
  return <div style={style}>{children}</div>
}
